import { safeStringify } from '../utils/objectTransforms';
import { getBackendLogDispatch } from '../store/logDispatch';
import type { LogError } from '../store/actions/backendCommon';

const getLogDispatch = () => getBackendLogDispatch();
const isRecord = (value: unknown): value is Record<string, unknown> => Boolean(value) && typeof value === 'object' && !Array.isArray(value);
const toLogOptions = (value: unknown): Record<string, unknown> | undefined => (isRecord(value) ? value : undefined);
const toLogError = (error: unknown): LogError => (typeof error === 'string' || error instanceof Error ? error : 'Unknown error');

export const captureException = (error: unknown) => {
    console.error(error);

    const dispatchLog = getLogDispatch();
    if (dispatchLog) {
        dispatchLog(toLogError(error));
    }
};

export const captureWarnMessage = (message = '', options: unknown = null) => {
    if (options) {
        console.warn(message, safeStringify(options));
    } else {
        console.warn(message);
    }

    const dispatchLog = getLogDispatch();
    if (dispatchLog) {
        dispatchLog(message, 'warn', toLogOptions(options));
    }
};

export const captureInfoMessage = (message = '', options: unknown = null) => {
    const dispatchLog = getLogDispatch();
    if (dispatchLog) {
        dispatchLog(message, 'info', toLogOptions(options));
    }
};
